var map = {
	"./esg-profile.jpg": 6078,
	"./governence.jpg": 5988,
	"./insight-page-header.jpg": 6453,
	"./news-page-header.jpg": 6961,
	"./our-journey.jpg": 6159,
	"./social.jpg": 7077,
	"./sustainable.jpg": 8087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 710;